import _ from "lodash"
import moment from "moment"
import { formTabulations, fieldsMapping, thematisedDescCodeConnection } from "../../static/webform"

const getDefaultState = () => {
    return {
        provider: null,
        fields: [],
        familyElements: [],
        contact: null,
        extra: null,
        submitted: false,
        disabled: false,
        hideNextModal: false,
        capacities: [],
        roomRenting: {
            equipped_room_nb: null,
            max_capacity: null,
            multi_purpose_room_nb: null,
            rooms: [],
        },
        categoryFamilies: [],
        suggestedMedias: [],
        aspectSuggestedMedias: [],
        suggestedCommunications: [],
        suggestedOpeningDays: [],
        suggestedAddress: null,
        suggestedCommune: null,
        suggestedH24: false,
        sourcesLoaded: false,
        isDirty: false,
        aiEnabled: false,
        id: null,
        acceptCgu: false,
        copyrightDialog: false,
        hasConfirmedCopyrights: false,
        pricePeriodDialog: false,
        hasConfirmedPricePeriods: false,
        openingPeriodDialog: false,
        hasConfirmedOpeningPeriods: false,
        baseOpeningPeriods: null,
        basePricePeriods: null,
        baseProviderHash: null,
        initProvider: null,
        communes: [],
        contactCommunes: [],
        searchCommunes: null,
        searchContactCommunes: null,
        mediaFullScreenDialog: false,
        switchMediaDialog: false,
        addOpeningPeriodDialog: false,
        addPricePeriodDialog: false,
        addApidaeContactDialog: false,
        forbiddenCriteriaDialog: false,
        currentOpeningPeriod: null,
        currentPricePeriod: null,
        currentApidaeContact: null,
        currentMedia: null,
        displayThanks: false,
        tabulations: [],
        origin: null,
        isOpenForm: false,
        preview: false,
        currency: null,
        currencies: [],
        aspect: null,
        editedTabulations: [],
        thematisedDescCriterias: [],
        forbiddenThematisedDesc: [],
        forbiddenElements: [],
        allSuggestedMediasLoaded: false,
        readOnly: false,
        generalTabDirty: false,
        localisationTabDirty: false,
        communicationTabDirty: false,
        mediasTabDirty: false,
        platformTabDirty:false,
        specificTabDirty: false,
        openingTabDirty: false,
        pricesTabDirty: false,
        contactsTabDirty: false,
        cardName: '',
        hasAspectData: true,
        accountTisType: null,
        deeplTranslatorEnabled: false,
        address2TooLong: false,
        openingPeriodTooLong: false,
    }
}

const web_form = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setProvider(state, data) {
            state.provider = data
        },
        setFields(state, data) {
            state.fields = data
        },
        setCurrency(state, data) {
            state.currency = data
        },
        setCurrencies(state, data) {
            state.currencies = data
        },
        setFamilyElements(state, data) {
            state.familyElements = data
        },
        setExtra(state, data) {
            state.extra = data
        },
        setSubmitted(state, data) {
            state.submitted = data
        },
        setDisabled(state, data) {
            state.disabled = data
        },
        setCapacities(state, data) {
            if (Array.isArray(data)) {
                data = data.map(element => {
                    let capacity = (state.provider && Array.isArray(state.provider.capacities))
                        ? state.provider.capacities.find(cap => {
                            let capId = cap.element !== undefined ? cap.element.id : cap.id
                            return capId === element.id
                        })
                        : undefined

                    let value = (capacity !== undefined && capacity.value !== null && capacity.value !== undefined)
                        ? capacity.value
                        : undefined

                    return {
                        ...element,
                        value,
                    }
                })
            }

            state.capacities = data
        },
        setRoomRenting(state, data) {
            if (data !== null && data.equipped_room_nb !== undefined) {
                state.roomRenting = data
            }
        },
        setCategoryFamilies(state, data) {
            state.categoryFamilies = data
        },
        setMediaFullScreenDialog(state, data) {
            state.mediaFullScreenDialog = data
        },
        setSwitchMediaDialog(state, data) {
            state.switchMediaDialog = data
        },
        setAddOpeningPeriodDialog(state, data) {
            state.addOpeningPeriodDialog = data
        },
        setAddPricePeriodDialog(state, data) {
            state.addPricePeriodDialog = data
        },
        setAddApidaeContactDialog(state, data) {
            state.addApidaeContactDialog = data
        },
        setAiEnabled(state, data) {
            state.aiEnabled = data
        },
        setId(state, data) {
            state.id = data
        },
        setAcceptCgu(state, data) {
            state.acceptCgu = data
        },
        setCopyrightDialog(state, data) {
            state.copyrightDialog = data
        },
        setForbiddenCriteriaDialog(state, data) {
            state.forbiddenCriteriaDialog = data
        },
        confirmCopyrightDialog(state, data) {
            state.copyrightDialog = false
            state.hasConfirmedCopyrights = true
        },
        setPricePeriodDialog(state, data) {
            state.pricePeriodDialog = data
        },
        confirmPricePeriodDialog(state, data) {
            state.pricePeriodDialog = false
            state.hasConfirmedPricePeriods = true
        },
        setOpeningPeriodDialog(state, data) {
            state.openingPeriodDialog = data
        },
        setAllSuggestedMediasLoaded(state, value) {
            state.allSuggestedMediasLoaded = value
        },
        confirmOpeningPeriodDialog(state, data) {
            state.openingPeriodDialog = false
            state.hasConfirmedOpeningPeriods = true
        },
        setCurrentOpeningPeriod(state, data) {
            state.currentOpeningPeriod = data
        },
        setCurrentPricePeriod(state, data) {
            state.currentPricePeriod = data
        },
        setCurrentApidaeContact(state, data) {
            state.currentApidaeContact = data
        },
        setCurrentMedia(state, data) {
            state.currentMedia = data
        },
        setDisplayThanks(state, data) {
            state.displayThanks = data
        },
        setOrigin(state, data) {
            state.origin = data
        },
        setIsOpenForm(state, data) {
            state.isOpenForm = data
        },
        setPreview(state, data) {
            state.preview = data
        },
        setForbiddenCriteria(state, data) {
            state.forbiddenCriteria = data
        },
        setEditedTabulations(state, data) {
          state.editedTabulations = data
        },
        setThematisedDescCriterias(state, data) {
          state.thematisedDescCriterias = data
        },
        setGeneralTabDirty(state, data) {
          state.generalTabDirty = data
        },
        setLocalisationTabDirty(state, data) {
            state.localisationTabDirty = data
        },
        setCommunicationTabDirty(state, data) {
            state.communicationTabDirty = data
        },
        setPlatformTabDirty(state, data) {
            state.platformTabDirty = data
        },
        setMediaTabDirty(state, data) {
            state.mediasTabDirty = data
        },
        setOpeningTabDirty(state, data) {
            state.openingTabDirty = data
        },
        setPricesTabDirty(state, data) {
            state.pricesTabDirty = data
        },
        setContactTabDirty(state, data) {
            state.contactsTabDirty = data
        },
        setSpecificTabDirty(state, data) {
          state.specificTabDirty = data
        },
        setCardName(state, data) {
          state.cardName = data
        },
        setHasAspectData(state, value) {
          state.hasAspectData = value
        },
        setAccountTisType(state, data) {
          state.accountTisType = data
        },
        setDeeplTranslatorEnabled(state, data) {
          state.deeplTranslatorEnabled = data
        },
        setAddress2TooLong(state, data) {
          state.address2TooLong = data
        },
        setOpeningPeriodTooLong(state, data) {
            state.openingPeriodTooLong = data
        },
        resetTabDiff(state) {
            state.generalTabDirty = false
            state.localisationTabDirty = false
            state.communicationTabDirty = false
            state.platformTabDirty = false
            state.mediasTabDirty = false
            state.openingTabDirty = false
            state.pricesTabDirty = false
            state.contactsTabDirty = false
            state.specificTabDirty = false
        },
        setDirtyTabulation(state, tab) {
            if(tab === 'GENERAL') {
                state.generalTabDirty = true
            } else if(tab === 'LOCALISATION') {
                state.localisationTabDirty = true
            } else if(tab === 'PLATFORM') {
                state.platformTabDirty = true
            } else if(tab === 'TARIF') {
                state.pricesTabDirty = true
            } else if(tab === 'COMMUNICATIONS') {
                state.communicationTabDirty = true
            } else if(tab === 'MEDIAS') {
                state.mediasTabDirty = true
            } else if(['ACTIVITE', 'HOTELLERIE', 'COMMERCE_ET_SERVICE', 'EQUIPEMENT', 'HEBERGEMENT_COLLECTIF',
                'HEBERGEMENT_LOCATIF', 'HOTELLERIE_PLEIN_AIR', 'PATRIMOINE_CULTUREL', 'PATRIMOINE_NATUREL',
                'PRODUCTEUR', 'RESTAURATION', 'FETE_ET_MANIFESTATION'].includes(tab)){
                state.specificTabDirty = true
            }
        },
        pushForbiddenThematisedDesc(state, data) {
           state.forbiddenThematisedDesc.push(data)
        },
        updateProvider(state, data) {
            state.provider = data
        },
        updateContent(state, data) {
            state.provider.contents = data
        },
        addElement(state, element) {
            state.provider.elements.push(element)
        },
        removeElement(state, element) {
            state.provider.elements.forEach((el, index) => {
                if (el.id === element.id) {
                    state.provider.elements.splice(index, 1)
                }
            })
        },
        updateBooleanElement(state, [value, code]) {
            state.provider.boolean_elements.forEach((elt, index) => {
                if (elt.attribute.code === code) {
                    state.provider.boolean_elements[index].value = value
                }
            })
        },
        updateNumericFields(state, [value, code]) {
            state.provider.numeric_fields.forEach((elt, index) => {
                if (elt.attribute.code === code) {
                    state.provider.numeric_fields[index].value = value
                }
            })
        },
        pushBooleanElement(state, value) {
            state.provider.boolean_elements.push(value)
        },
        pushNumericField(state, value) {
            state.provider.numeric_fields.push(value)
        },
        setContact(state, value) {
            state.contact = value
        },
        setHideNextModal(state, value) {
            state.hideNextModal = value
        },
        removeMedia(state, index) {
            state.provider.medias.splice(index, 1)
        },
        addMedia(state, value) {
            state.provider.medias.push(value)
        },
        addRoom(state, value) {
            state.roomRenting.rooms.push(value)
        },
        deleteRoom(state, index) {
            state.roomRenting.rooms.splice(index, 1)
        },
        addContact(state, value) {
            state.provider.contacts.push(value)
        },
        updateContact(state, [index, value]) {
            state.provider.contacts[index] = value
        },
        deleteContact(state, index) {
            state.provider.contacts.splice(index, 1)
        },
        pushSuggestedMedias(state, value) {
            state.suggestedMedias = [...state.suggestedMedias, ...value]
        },
        pushAspectSuggestedMedias(state, value) {
          state.aspectSuggestedMedias = [...state.aspectSuggestedMedias, ...value]
        },
        pushSuggestedCommunications(state, value) {
            state.suggestedCommunications = [...state.suggestedCommunications, ...value]
        },
        setSuggestedMedias(state, value) {
            state.suggestedMedias = value
        },
        setAspectSuggestedMedias(state, value) {
          state.aspectSuggestedMedias = value
        },
        setSourcesLoaded(state, value) {
            state.sourcesLoaded = value
        },
        setSuggestedOpeningDays(state, value) {
            state.suggestedOpeningDays = [...state.suggestedOpeningDays, ...value]
        },
        setEmptySuggestedOpeningDays(state) {
            state.suggestedOpeningDays = []
        },
        setSuggestedAddress(state, value) {
            state.suggestedAddress = value
        },
        setSuggestedCommune(state, value) {
            state.suggestedCommune = value
        },
        setSuggestedH24(state, value) {
            state.suggestedH24 = value
        },
        setIsDirty(state, value) {
            state.isDirty = value
        },
        setCommunes(state, value) {
            state.communes = value
        },
        pushCommune(state, value) {
            state.communes.push(value)
        },
        setContactCommunes(state, value) {
            state.contactCommunes = value
        },
        pushContactCommune(state, value) {
            state.contactCommunes.push(value)
        },
        setSearchCommunes(state, value) {
            state.searchCommunes = value
        },
        setSearchContactCommunes(state, value) {
            state.searchContactCommunes = value
        },
        setBaseOpeningPeriods(state) {
            let baseOpeningPeriods = JSON.parse(JSON.stringify(state.initProvider.opening_periods))

            baseOpeningPeriods.forEach(period => {
                if (period.external_id !== null && period.external_id !== undefined) {
                    period.external_id = period.external_id.toString()
                }
            })

            state.baseOpeningPeriods = baseOpeningPeriods
        },
        setBasePricePeriods(state) {
            let basePricePeriods = JSON.parse(JSON.stringify(state.initProvider.price_periods))

            basePricePeriods.forEach(period => {
                delete period.selectedElements
                delete period.availableElements
                delete period.currency

                period.valid_from = moment(period.valid_from).format("YYYY-MM-DD HH:mm:ss")
                period.valid_through = moment(period.valid_through).format("YYYY-MM-DD HH:mm:ss")

                if (period.external_id !== null && period.external_id !== undefined) {
                    period.external_id = period.external_id.toString()
                }
            })

            state.basePricePeriods = basePricePeriods
        },
        setBaseProviderHash(state, value) {
            state.baseProviderHash = value
        },
        setInitProvider(state, initProvider) {
            initProvider.opening_periods.forEach(period => {
                if (period.opening_days === undefined) {
                    period.opening_days = [
                        { closed: true, day_of_week: 0 },
                        { closed: true, day_of_week: 1 },
                        { closed: true, day_of_week: 2 },
                        { closed: true, day_of_week: 3 },
                        { closed: true, day_of_week: 4 },
                        { closed: true, day_of_week: 5 },
                        { closed: true, day_of_week: 6 },
                    ]
                }

                period.opening_days.forEach(day => {
                    if (day.opening_hours === undefined) {
                        day.opening_hours = []
                    }
                })
            })
            initProvider.price_periods.forEach(period => {
                period.prices.forEach(price => {
                    if (price.min !== null) {
                        price.min /= 100
                    }

                    if (price.max !== null) {
                        price.max /= 100
                    }
                })
            })

            state.initProvider = initProvider
        },
        setReadOnly(state, value) {
            state.readOnly = value
        },
        formatPricePeriods: (state) => {
            if (state.provider.price_periods !== undefined && state.provider.price_periods !== null) {
                state.provider.price_periods.forEach(pricePeriod => {
                    pricePeriod.prices.map(price => {
                        price.min /= 100
                        price.max /= 100

                        return price
                    })
                })
            }
            if (state.provider && state.provider.booking_links !== undefined) {
                if (!state.provider.booking_links) {
                    state.provider.booking_links = []
                }
                const types = ["WEBSITE", "WEBSITE_EN"]
                types.forEach(typeName => {
                    if (!state.provider.booking_links.some(link => _.get(link, "type.name") === typeName)) {
                        state.provider.booking_links.push({
                            type: {
                                name: typeName,
                            },
                            value: null,
                        })
                    }
                })
            }
        },
        formatContents: (state, languages) => {
            if (state.provider.contents !== undefined && state.provider.contents !== null) {
                let contents = []

                languages.forEach(language => {
                    let providerContent = state.provider.contents.find((content) => content.language.code === language.code)

                    let content = {
                        language: language,
                        description: providerContent !== undefined ? providerContent.description : null,
                        description_long: providerContent !== undefined ? providerContent.description_long : null,
                        description_theme_covid: providerContent !== undefined ? providerContent.description_theme_covid : null,
                        description_sustainable_tourism: providerContent !== undefined ? providerContent.description_sustainable_tourism : null,
                        description_portrait: providerContent !== undefined ? providerContent.description_portrait : null,
                        description_2023_innovation: providerContent !== undefined ? providerContent.description_2023_innovation : null,
                        description_2024_innovation: providerContent !== undefined ? providerContent.description_2024_innovation : null,
                        description_2025_innovation: providerContent !== undefined ? providerContent.description_2025_innovation : null,
                        description_2026_innovation: providerContent !== undefined ? providerContent.description_2026_innovation : null,
                        description_2027_innovation: providerContent !== undefined ? providerContent.description_2027_innovation : null,
                        description_unavoidable: providerContent !== undefined ? providerContent.description_unavoidable : null,
                        description_animals_welcome: providerContent !== undefined ? providerContent.description_animals_welcome : null,
                        description_party_menu: providerContent !== undefined ? providerContent.description_party_menu : null,
                        description_good_reasons: providerContent !== undefined ? providerContent.description_good_reasons : null,
                        desc_handi_auditif: providerContent !== undefined ? providerContent.desc_handi_auditif : null,
                        desc_handi_moteur: providerContent !== undefined ? providerContent.desc_handi_moteur : null,
                        desc_handi_visuel: providerContent !== undefined ? providerContent.desc_handi_visuel : null,
                        desc_handi_mental: providerContent !== undefined ? providerContent.desc_handi_mental : null,
                        offer_promotions: providerContent !== undefined ? providerContent.offer_promotions : null,
                        chef: providerContent !== undefined ? providerContent.chef : null,
                        complement_accueil: providerContent !== undefined ? providerContent.complement_accueil : null,
                        citq_number: providerContent !== undefined ? providerContent.citq_number : null,
                        quebec_total_capacity: providerContent !== undefined ? providerContent.quebec_total_capacity : null,
                        alerte: providerContent !== undefined ? providerContent.alerte : null,
                        cruisers_service: providerContent !== undefined ? providerContent.cruisers_service : null,
                        gift_certificate: providerContent !== undefined ? providerContent.gift_certificate : null,
                        advices_suggestions: providerContent !== undefined ? providerContent.advices_suggestions : null,
                        child_service: providerContent !== undefined ? providerContent.child_service : null,
                        cyclist_service: providerContent !== undefined ? providerContent.cyclist_service : null,
                        riders_service: providerContent !== undefined ? providerContent.riders_service : null,
                        hikers_service: providerContent !== undefined ? providerContent.hikers_service : null,
                        takeaway: providerContent !== undefined ? providerContent.takeaway : null,
                        wines_label: providerContent !== undefined ? providerContent.wines_label : null,
                        agrement_number: providerContent !== undefined ? providerContent.agrement_number : null,
                    }

                    contents.push(content)
                })

                state.provider.contents = contents
            }
        },
        formatCommunications: (state, contacts) => {
            contacts.forEach(contact => {
                let hasEntry = false

                state.provider.communications.forEach(com => {
                    if (com.type.name === contact.name) {
                        hasEntry = true
                    }
                })

                if (!hasEntry) {
                    state.provider.communications.push({
                        value: null,
                        type: contact,
                    })
                }
            })
        },
        updateProviderFieldValue: (state, [path, value]) => {
            const directPath = path.path !== null ? path.path : path

            if (path.filter !== null) {
                if (!state.provider[directPath]) {
                    state.provider[directPath] = []
                }
                let obj = state.provider[directPath].find(item => _.get(item, path.filter.path) === path.filter.value)

                if (obj !== undefined && path.property !== undefined) {
                    obj[path.property] = value
                } else if (obj === undefined && path.property !== undefined) {
                    let newObj = {}
                    _.set(newObj, path.filter.path, path.filter.value)
                    newObj[path.property] = value
                    state.provider[directPath].push(newObj)
                }
            } else if (path.property !== undefined && path.property !== null) {
                _.set(state.provider, directPath + "." + path.property, value)
            } else {
                state.provider[directPath] = value
            }
        },

        generateTabulations: (state, sit) => {
            let uniqueTabulations = state.fields.map(field => {
                return { code: field.tabulation.code }
            })

            const hasCapacityField = state.fields.find(field => field.fieldable.name === "Capacites")
            const family = state.familyElements.find(family => family.name === "Capacites")

            const hasDescPartyMenuField = state.fields.find(field => field.fieldable.code === "DESC_PARTY_MENU")

            if (hasDescPartyMenuField && uniqueTabulations.find(tab => tab.code === "GENERAL") === undefined) {
                uniqueTabulations.push({ code: "GENERAL" })
            }

            if (hasCapacityField && family && family.elements.length) {
                uniqueTabulations.push({ code: "CAPACITES" })
            }

            uniqueTabulations = [...new Map(uniqueTabulations.map(item => [item["code"], item])).values()]
            if(!sit) {
                uniqueTabulations.push({ code: "FORM_VALIDATION" })
            }
            uniqueTabulations.push({ code: "PRIVATE_DESC" })

            let tabulations = formTabulations.filter(formTab => {
                return uniqueTabulations.find(tab => tab.code === formTab.code)
            })

            tabulations[0].active = true

            if(state.editedTabulations !== null) {
                tabulations.forEach(tab => {
                    let editedTab = state.editedTabulations.find(t => {
                        return t.code === tab.code
                    })
                    if (editedTab) {
                        tab.new_title = editedTab.pivot ? editedTab.pivot.new_title : editedTab.new_title
                        tab.help_description = editedTab.pivot ? editedTab.pivot.help_description : editedTab.help_description
                    }
                })
            }

            state.tabulations = tabulations
        },

        orderTabulations: (state) => {
            let index = 1

            state.tabulations.forEach(tab => {
                if (!tab.hidden) {
                    tab.index = index

                    index++
                }
            })
        },

        handleSpecificTabulation: (state) => {
            state.tabulations.forEach((tab, index) => {
                if (tab.anchor === "specific-tab") {
                    const category = tab.code

                    let fields = state.fields.filter(field => {
                        return field.tabulation.code === category
                    })

                    fields = fields.filter(field => field.fieldable.code !== "DESC_PARTY_MENU" && field.fieldable.name !== "Capacites")

                    fields = fields.filter(field => {
                        if (field.fieldable_type === "App\\Models\\Referential\\FamilyElement") {
                            const family = state.familyElements.find(family => family.name === field.fieldable.name)
                            const elements = family !== undefined ? family.elements : []

                            return elements.length > 0
                        } else {
                            return field
                        }
                    })

                    if (fields.length === 0) {
                        state.tabulations.splice(index, 1)
                    }
                }
            })
        },
        generateTabActiveRanges: (state) => {
            state.tabulations.forEach(tab => {
                let element = document.getElementsByClassName(tab.anchor)

                if (element !== undefined && element.length > 0) {
                    element = element[0]

                    let offsetTop = element.offsetTop
                    let height = element.offsetHeight
                    let offsetBot = offsetTop + height

                    tab.offsetBot = offsetBot - 1
                    tab.offsetTop = offsetTop
                }
            })
        },

        setBooleanFieldValues: (state) => {
            const fields = fieldsMapping.filter(field => field.path === "boolean_elements")

            if (fields) {
                fields.forEach(field => {
                    const exist = state.provider.boolean_elements &&
                      state.provider.boolean_elements.find(element => element.attribute.code === field.code)

                    if (!exist && state.provider.boolean_elements) {
                        state.provider.boolean_elements.push({
                            attribute: { code: field.code },
                            value: null,
                        })
                    }
                })
            }
        },

        setNumericFieldValues: (state) => {
            const fields = fieldsMapping.filter(field => field.path === "numeric_fields")

            if (fields) {
                fields.forEach(field => {
                    const exist = state.provider.numeric_fields &&
                      state.provider.numeric_fields.find(element => element.attribute.code === field.code)

                    if (!exist && state.provider.numeric_fields) {
                        state.provider.numeric_fields.push({
                            attribute: { code: field.code },
                            value: null,
                        })
                    }
                })
            }
        },

        setDateFieldValues: (state) => {
            const fields = fieldsMapping.filter(field => field.path === "date_fields")

            if (fields) {
                fields.forEach(field => {
                    const exist = state.provider.date_fields &&
                      state.provider.date_fields.find(_field => _field.code === field.code)

                    if (!exist && state.provider.date_fields) {
                        state.provider.date_fields.push({
                            code: field.code,
                            value: null,
                        })
                    }
                })
            }
        },
        setAspect(state, value) {
          state.aspect = value
        },
        updateForbiddenThematisedDesc(state) {
            state.forbiddenThematisedDesc = []
            state.forbiddenElements = []
            let frenchContents = state.provider.contents.find(content => content.language.code === 'fr')

            thematisedDescCodeConnection.forEach( desc => {
                if(frenchContents && frenchContents[desc.name] !== null && frenchContents[desc.name] !== '' && frenchContents[desc.name] !== undefined) {

                    let descCriteria = state.thematisedDescCriterias.find(
                      descCriterias => descCriterias.code === desc.code)
                    let forbiddenCriterias = (descCriteria && Array.isArray(descCriteria.forbiddenBy)) ? descCriteria.forbiddenBy : []

                    let isForbidden = false
                    let blockingElements = []

                    forbiddenCriterias.forEach(apidaeElementId => {
                        state.provider.elements.forEach(element => {
                            if(element.apidae_element_id === apidaeElementId) {
                                isForbidden = true
                                blockingElements.push(element.label)
                                state.forbiddenElements.push(element.apidae_element_id)
                            }
                        })
                    })

                    if(isForbidden) {
                        state.forbiddenThematisedDesc.push({
                            'code' : desc.code,
                            'blockingElements' : blockingElements,
                        })
                    }
                }
            })
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        },
    },
    getters: {
        hasField: (state) => code => {
            return state.fields.find(field => field.fieldable.code === code.toUpperCase()) !== undefined ||
              state.fields.find(field => field.fieldable.name === code) !== undefined
        },
        getFieldsFromTabulation: (state) => code => {
            return state.fields.filter(field => {
                return field.tabulation.code === code
            })
        },
        getField: (state) => code => {
            let field = state.fields.find(field => {
                let fieldCode = field.fieldable.code !== undefined ? field.fieldable.code.toUpperCase() : null


                return fieldCode === code.toUpperCase()
            })

            if (field === undefined) {
                field = state.fields.find(field => {
                    let name = field.fieldable.name !== undefined ? field.fieldable.name.toUpperCase() : null

                    return name === code.toUpperCase()
                })
            }

            return field
        },
        getRequiredFields: (state) => {
            return state.fields.filter(field => field.required && !field.skipped)
        },
        getSkippedFields: (state) => {
            return state.fields.filter(field => field.skipped)
        },
        hasFamilyElement: (state, getters) => code => {
            let family = state.familyElements.find(family => family.name === code)

            return family !== undefined && family.elements.length > 0 && getters.hasField(code)
        },
        getFamilyByCode: (state) => code => {
            let family = state.familyElements.find(family => family.name === code)

            return family !== undefined ? family.elements : []
        },
        getElementsByFamilyCode: (state) => (code, multiplicity) => {
            let elements = state.provider.elements.filter(element => element.family.name === code)

            if (multiplicity) {
                if (elements.length) {
                    elements = elements[0]
                } else {
                    elements = {}
                }
            }

            return elements
        },
        getElementsByFamilyId: (state) => (id, multiplicity) => {
            let elements = state.provider.elements.filter(element => element.family_id === id)

            if (multiplicity) {
                if (elements.length) {
                    elements = elements[0]
                } else {
                    elements = {}
                }
            }

            return elements
        },
        getCodeFromField: () => (field) => {
            return field.fieldable_type === "App\\Models\\Referential\\Attribute" ?
              field.fieldable.code :
              field.fieldable.name
        },
        getProviderFieldValue: (state) => (path) => {
            if (path === null) {
                return null
            }

            let value = state.provider[path.path]

            if (path.filter !== null) {
                let obj = value && Array.isArray(value) ? value.find(item => _.get(item, path.filter.path) === path.filter.value) : undefined

                if (obj !== undefined && path.property !== undefined) {
                    value = obj[path.property]
                } else if (path.property !== undefined) {
                    value = null
                } else {
                    value = []
                }
            } else if (path.property !== undefined && path.property !== null) {
                value = value[path.property]
            }

            return value
        },
    },
}

export default web_form